import * as React from 'react'
import ReactDOM from 'react-dom'

import { Button } from '../../main/components/button'
import { Topbar } from '../maps/components/Topbar'
import { QueryClientContext } from '../shared/components/QueryClientContext'
import { Share } from './Share'
import BubbleActionCreators from './actions/bubbleActionCreators'
import { BubbleChart } from './bubbleChart'
import BubblesHover from './bubblesHover'
import { BUBBLES_SETTINGS } from './constants/settings'
import { Presets } from './presets'
import { SidebarContent } from './sidebar'
import { BubblesLoadParam } from './types'
import { decodeQueryString, encodeQueryString } from './utils'

const linkClassName = 'text-link hover:text-gray-50'

function Bubbles() {
  const queryString = decodeQueryString(true)

  const onChange = React.useRef((values: any) => {
    let query = encodeQueryString(values)

    if (query.length) query = `?${query}`

    document.location.href = `/bubbles.ashx${query}`
  }).current

  return (
    <div>
      <Topbar
        className="border-finviz-blue-gray bg-[#363a46] text-[#94a3b8] shadow"
        navContent={
          <>
            <h2 className="m-0 text-2xs uppercase opacity-50">View</h2>
            <Button as="a" href="/map.ashx" leftContent="chartTreemap" theme="transparent" className={linkClassName}>
              Map
            </Button>
            <Button as="a" href="/bubbles.ashx" leftContent="chartBubble" theme="transparent" className="text-gray-50">
              Bubbles
            </Button>
          </>
        }
        mapControls={
          <div className="pr-2">
            <Share extendedFilters className={linkClassName} />
          </div>
        }
      />
      <div className="bubbles-container">
        <div className="sidebar w-[200px]">
          <div className="mb-0.5 bg-[#404553] p-5 pt-3">
            <div className="border-b border-gray-700">
              <div className="-mx-2 mb-1 flex items-center justify-between py-1">
                <Presets isDark className={linkClassName} />
                <Button theme="transparent" className={linkClassName} onClick={() => onChange({})}>
                  Reset
                </Button>
              </div>
            </div>
            <SidebarContent extendedFilters selected={queryString} onChange={onChange} linkClassName={linkClassName} />
          </div>
        </div>
        <div className="flex flex-1 flex-col">
          <div id="map">
            <div id="body" className="relative">
              <BubbleChart settings={BUBBLES_SETTINGS} />
              <BubblesHover
                labelX={queryString['x']}
                labelY={queryString['y']}
                labelSize={queryString['size']}
                labelColor={queryString['color']}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

window['FinvizInitBubbles'] = function () {
  BubbleActionCreators.load('/api/bubbles.ashx', decodeQueryString(true) as unknown as BubblesLoadParam)
  ReactDOM.render(
    <QueryClientContext>
      <Bubbles />
    </QueryClientContext>,
    document.getElementById('bubbles')
  )
}
